// Single source of truth for the licenses the registration flow actually lets
// a user pick (CommonlyUsedLicences short list + CC-Kit variants + the two
// special values). Used both by the register step and by the search filter so
// the filter only ever offers licenses that works can actually be created with.

// SPDX identifiers promoted across the "commonly used" lists (union over all
// work types) plus the CC-Kit outputs.
export const COMMON_LICENCE_IDS = [
  "CC0-1.0",
  "CC-BY-4.0",
  "CC-BY-SA-4.0",
  "CC-BY-NC-4.0",
  "CC-BY-ND-4.0",
  "CC-BY-NC-ND-4.0",
  "CC-BY-NC-SA-4.0",
  "EUPL-1.2",
  "LAL-1.3",
  "ODbL-1.0",
  "CERN-OHL-P-2.0",
  "CERN-OHL-S-2.0",
];

// Non-SPDX values the register flow can also store as the work's license.
// Keyed by the exact identifier persisted on the work (see CommonlyUsedLicences
// / CCKitHelper) so the filter matches what is actually in the data.
export const SPECIAL_LICENCES = [
  { id: "FullCopyright", labelKey: "RegisterWork.License.CommonRightsReserved" },
  { id: "NoAssertion", labelKey: "RegisterWork.License.NoAssertion" },
];
